import { jsx as a } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import r from "./styles.module.less.js";
const d = p((e, l) => {
  var t;
  const { value: s, disabled: o, onChange: n, children: c, error: m } = e;
  return /* @__PURE__ */ a("div", { className: `${r.selectContainer}`, children: /* @__PURE__ */ a(
    "select",
    {
      ref: l,
      ...e.props,
      className: `${r.selectInput} ${((t = e.props) == null ? void 0 : t.className) || ""} ${m ? r.error : ""}`,
      value: s || "",
      onChange: (i) => n(i.target.value),
      disabled: o,
      children: c
    }
  ) });
});
d.displayName = "SelectInput";
export {
  d as SelectInput
};
